import { IACDLEvent } from '../../../services/eventBus.service';

export const WorkspaceCreatedEventType = Symbol('WORKSPACE_CREATED_EVENT');

export class WorkspaceCreatedEvent implements IACDLEvent {
  constructor(public newWorkspaceId: string) {}

  readonly type: symbol = WorkspaceCreatedEventType;
}
